export const GA4ecommerceAnalyticsObject = spreeObject => {
  // This is for Google Analytics
  const ecommerceAnalyticsObject = {};

  const propertiesMap = {
    item_name: {
      parentObj: 'included',
      attribute: '_analytics_item_name',
    },
    item_id: {
      parentObj: 'included',
      attribute: '_analytics_item_id',
    },
    price: {
      attribute: 'price',
    },
    item_brand: {
      parentObj: 'included',
      attribute: '_analytics_item_brand',
    },
    // 'item_category' is set below
    item_category2: {
      parentObj: 'included',
      attribute: '_analytics_product_line',
    },
    item_product_line: {
      parentObj: 'included',
      attribute: '_analytics_product_line',
    },
    item_category3: {
      parentObj: 'included',
      attribute: '_analytics_page_slug',
    },
    item_page_slug: {
      parentObj: 'included',
      attribute: '_analytics_page_slug',
    },
    item_category4: {
      parentObj: 'included',
      attribute: '_analytics_page_variant_slug',
    },
    item_page_variant_slug: {
      parentObj: 'included',
      attribute: '_analytics_page_variant_slug',
    },
    gauge: {
      parentObj: 'included',
      attribute: '_analytics_gauge',
    },
    edge_finish: {
      parentObj: 'included',
      attribute: '_analytics_edge_finish',
    },
  };

  Object.entries(propertiesMap).forEach(property => {
    if (!property[1].parentObj) {
      ecommerceAnalyticsObject[property[0]] =
        spreeObject.data.attributes[property[1].attribute];
    } else {
      if (spreeObject.included?.length > 0) {
        const foundObj =
          spreeObject.included.find(
            obj => obj.attributes.name === property[1].attribute
          ) || null;
        if (foundObj) {
          ecommerceAnalyticsObject[property[0]] = foundObj.attributes.value;
        }
      }
    }
  });

  // Set 'item_category' value
  const vendorsMap = {
    '1': 'Samples',
    '2': 'Hardware',
    '9': 'Full Sheets',
  };
  const vendor =
    vendorsMap[spreeObject?.data?.relationships?.vendor?.data?.id] || null;
  if (vendor) {
    ecommerceAnalyticsObject['item_category'] = vendor;
    ecommerceAnalyticsObject['item_vendor'] = vendor;
  }

  // GA4 multiplies price by quantity, so both have to be numbers. Spree only
  // carries a quantity once the item is a line item; before that it is one.
  ecommerceAnalyticsObject['price'] =
    Number(ecommerceAnalyticsObject['price']) || 0;
  ecommerceAnalyticsObject['quantity'] =
    Number(spreeObject?.data?.attributes?.quantity) || 1;

  return ecommerceAnalyticsObject;
};
